import { Span } from "@opentelemetry/sdk-trace-base";

import { log, warn } from "./logger";
import { SanitizedSpanAttributes, sanitizeSpanAttributes } from "./spanAttributes";

const emitGlobalAttributeLog = (
  message: string,
  attributes: Record<string, unknown> = {},
) => {
  log({
    message,
    attributes: {
      "l9rum.attributes.component": "GlobalSpanAttributes",
      ...attributes,
    },
  });
};

let globalSpanAttributes: SanitizedSpanAttributes = {};

const isPlainRecord = (value: unknown): value is Record<string, unknown> => {
  return !!value && typeof value === "object" && !Array.isArray(value);
};

export const setGlobalSpanAttributes = (
  attributes?: Record<string, unknown> | null,
): SanitizedSpanAttributes => {
  if (!isPlainRecord(attributes)) {
    if (Object.keys(globalSpanAttributes).length) {
      emitGlobalAttributeLog("[L9RUM SpanAttributes] Cleared global span attributes", {
        "l9rum.attributes.guard": "cleared",
      });
    }
    globalSpanAttributes = {};
    return globalSpanAttributes;
  }

  const sanitized = sanitizeSpanAttributes(attributes);
  globalSpanAttributes = sanitized;

  emitGlobalAttributeLog("[L9RUM SpanAttributes] Updated global span attributes", {
    "l9rum.attributes.keys": JSON.stringify(Object.keys(globalSpanAttributes)),
    "l9rum.attributes.count": Object.keys(globalSpanAttributes).length,
  });

  return globalSpanAttributes;
};

export const getGlobalSpanAttributes = (): SanitizedSpanAttributes => ({
  ...globalSpanAttributes,
});

export const injectGlobalSpanAttributes = (span: Span): number => {
  try {
    const attributes = getGlobalSpanAttributes();
    const entries = Object.entries(attributes);
    entries.forEach(([key, value]) => {
      span.setAttribute(key, value);
    });

    if (entries.length) {
      emitGlobalAttributeLog("[L9RUM SpanAttributes] Injected global span attributes", {
        "l9rum.attributes.span_name": (span as any).name,
        "l9rum.attributes.count": entries.length,
      });
    }

    return entries.length;
  } catch (err) {
    warn({
      message: "[L9RUM SpanAttributes] Failed to inject global span attributes",
      attributes: {
        "l9rum.attributes.component": "GlobalSpanAttributes",
        "l9rum.attributes.guard": "inject_failed",
      },
      error: err,
    });
    return 0;
  }
};
